// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__h9Pdj","form":"styles_form__17oMk"};